<ng-template #portabilityModal let-modal>
    <div class="modal-header bg-simyo-grey">
        <h5 class="modal-title white">Portabilidad Móvil</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onModalDismiss(modal, true)">
            <span aria-hidden="true"><img src="./assets/img/times2.svg" class="img-fluid ico-title" width="20" /></span>
        </button>
    </div>

    <div class="modal-body" id="bodyModal">
        <div class="container p-0">
            <div class="row m-0 portability-row text-center">
                <h6>
                    ¿Vas a realizar una portabilidad móvil pospago {{ onlyOneProvider ? ' de ' : '' }} <b>{{ onlyOneProvider ? serviceProviders[0].value : '' }}</b>?
                </h6>
            </div>

            <div class="row mx-0 my-4 justify-content-center gx-1" style="column-gap: 16px;">
                <div class="col-auto p-0">
                    <a (click)="showProviders()" [class.selected]="selected"
                        class="btn py-1 btn-simyo-o btn-portability py-1">Sí</a>
                </div>
                <div class="col-auto p-0">
                    <a (click)="respond('cancel', modal)" class="btn py-1 btn-simyo-o btn-portability py-1">No</a>
                </div>
            </div>

            <div *ngIf="showOperators" [ngClass]="onlyOneProvider && typeOrder == orderType.MOBILE ? 'm-0 p-0': 'mt-4 pt-2'">
                <form [formGroup]="portabilityForm" class="p-0">
                    <!-- Si hay más de un operador dentro del array serviceProviders, se debe seleccionar el operador donante. Sino, el selector se ocultará -->
                    <div *ngIf="!onlyOneProvider" class="row py-2" style="width: 67%; margin: 0 auto;">
                        <digo-select [label]="'Operador donante'" [options]="serviceProviders"
                            [formGroup]="portabilityForm" controlName="portability_operator" optionValue="value"
                            optionLabel="value" [returnFullObject]="true" [isRequired]="true"
                            [customeMessageError]="'Operador no válido'" class="select-operator"></digo-select>
                    </div>

                    <div class="row offer-section" *ngIf="showCommitmentContract">
                        <div class="col-12 p-0 label-offer">
                            Selecciona oferta*:
                        </div>

                        <!-- Opción CP 12 meses -->
                        <div class="col mt-2 option-box" (mouseenter)="isHovered12 = true"
                            (mouseleave)="isHovered12 = false"
                            [class.selected]="portabilityForm.get('commitment_option')?.value === '12'"
                            (click)="selectOffer('12')">
                            <div class="row m-0">
                                <div class="col-auto p-0">
                                    <mat-icon class="icon-radio">
                                        {{ portabilityForm.get('commitment_option')?.value === '12' ?
                                        'radio_button_checked' : 'radio_button_unchecked'}}
                                    </mat-icon>
                                </div>
                                <div class="col p-0">
                                    <div class="row m-0">
                                        <span class="p-0" [style.font-weight]="portabilityForm.get('commitment_option')?.value === '12' || isHovered12 ? '600' : '400'">CP 12 meses</span>
                                    </div>
                                    <div class="row m-0">
                                        <span class="p-0" [style.font-weight]="portabilityForm.get('commitment_option')?.value === '12' || isHovered12 ? '600' : '400'" style="font-size: 0.7rem;">(Oferta Mi Fibra)</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Opción CP 3 meses -->
                        <div class="col mt-2 option-box" (mouseenter)="isHovered3 = true"
                            (mouseleave)="isHovered3 = false"
                            [class.selected]="portabilityForm.get('commitment_option')?.value === '3'"
                            (click)="selectOffer('3')">
                            <div class="row m-0">
                                <div class="col-auto p-0">
                                    <mat-icon class="icon-radio">
                                        {{ portabilityForm.get('commitment_option')?.value === '3' ?
                                        'radio_button_checked' : 'radio_button_unchecked'}}</mat-icon>
                                </div>
                                <div class="col p-0">
                                    <div class="row m-0">
                                        <span class="p-0" [style.font-weight]="portabilityForm.get('commitment_option')?.value === '3' || isHovered3 ? '600' : '400'">CP 3 meses</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Error -->
                        <div class="col-12 m-0 p-0"
                            *ngIf="portabilityForm.get('commitment_option')?.touched && portabilityForm.get('commitment_option')?.invalid">
                            <span class="small-error">Debes seleccionar una oferta</span>
                        </div>
                    </div>

                    <div class="row mx-0 mt-5">
                        <div class="col p-0 text-end">
                            <a (click)="respond('accept', modal)" class="py-1 btn btn-simyo-o btn-portability" [class.selected]="portabilityForm.valid"
                                style="padding-top: 4px; padding-bottom: 4px; border-radius: 2px!important;">
                                Confirmar
                            </a>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</ng-template>

